@if (data.isDs) {
  <div mat-dialog-title class="ds">
    <span>{{ appStrings.quotes_searchQuotes || appStrings.quotesSearch_advancedSearch_title }}</span>
    <button mat-icon-button class="close-dialog-button" mat-dialog-close>
      <mat-icon class="close-icon">close</mat-icon>
    </button>
  </div>

  <div mat-dialog-content class="content ds" [ngClass]="{ 'mobile': isMobile, 'desktop': !isMobile }">
    <div class="content-container">
      <form [formGroup]="filterFormGroup" (keyup.enter)="searchText()">
        <div class="flex-row">
          <!-- Start Date picker -->
          <ds-date-picker id="startDateField" class="half-width" [label]="appStrings.quotesStartDate"
            label_orientation="vertical-label" [control]="filterFormGroup.controls.startDate"
            [date_format]="dsDateFormat"
          ></ds-date-picker>

          <!-- End Date picker -->
          <ds-date-picker id="endDateField" class="half-width" [label]="appStrings.quotesEndDate"
            label_orientation="vertical-label" [control]="filterFormGroup.controls.endDate"
            [date_format]="dsDateFormat"
          ></ds-date-picker>
        </div>

        <!-- Customer Name field -->
        @if (!data.isCustomerDashboard) {
          <div id="customerNameSearchForm">
            <ds-textfield id="customerNameField" class="fill-width" [label]="appStrings.quoteSearch_customerName"
              label_orientation="vertical-label" [control]="filterFormGroup.controls.customerName"
            ></ds-textfield>
          </div>
        }

        <!-- BP Number field -->
        @if (!data.isCustomerDashboard) {
          <div id="bpNumberSearchForm">
            <ds-textfield id="bpNumberField" class="fill-width" [label]="appStrings.quoteSearch_bpNumber"
              label_orientation="vertical-label" [control]="filterFormGroup.controls.bpNumber"
              placeholder="Ex. 0123456789"
            ></ds-textfield>
          </div>
        }

        <!-- Quote Name field -->
        <ds-textfield id="quoteNameField" class="fill-width" [label]="appStrings.quoteSearch_quoteName"
          label_orientation="vertical-label" [control]="filterFormGroup.controls.quoteName"
        ></ds-textfield>

        <!-- Quote Number field -->
        <ds-textfield id="quoteNumberField" class="fill-width" [label]="appStrings.quoteSearch_quoteNumber"
          label_orientation="vertical-label" [control]="filterFormGroup.controls.quoteNumber"
          placeholder="Ex. IMP-000011111"
        ></ds-textfield>

        <!-- Confidence to Close field -->
        <ds-select id="confidenceField" class="fill-width" [label]="appStrings.quoteSearch_confidencePct"
          [dropOptions]="confidenceOptions" label_orientation="vertical-label"
          [control]="filterFormGroup.controls.confidence"
        ></ds-select>

        <!-- Expiring in Days field -->
        <ds-textfield id="expiringField" class="fill-width" [label]="appStrings.quoteSearch_expiringInDays"
          label_orientation="vertical-label" [control]="filterFormGroup.controls.expiringInDays"
        ></ds-textfield>

        <!-- Dollar Amount field -->
        <ds-textfield id="dollarAmountField" class="fill-width" [label]="displayedTextAmount"
          label_orientation="vertical-label" [control]="filterFormGroup.controls.dollarAmount"
          [start_adornment_type]="displayCurrency ? 'text' : null" [start_adornment_value_text]="currencySymbol"
        ></ds-textfield>

        <!-- Dollar Ranges Min field -->
        <ds-textfield id="dollarRangesMinField" class="fill-width" [label]="displayedTextRangesFrom"
          label_orientation="vertical-label" [control]="filterFormGroup.controls.dollarRangeMin"
          [start_adornment_type]="displayCurrency ? 'text' : null" [start_adornment_value_text]="currencySymbol"
        ></ds-textfield>

        <!-- Dollar Ranges Max field -->
        <ds-textfield id="dollarRangesMaxField" class="fill-width" [label]="displayedTextRangesTo"
          label_orientation="vertical-label" [control]="filterFormGroup.controls.dollarRangeMax"
          [start_adornment_type]="displayCurrency ? 'text' : null" [start_adornment_value_text]="currencySymbol"
        ></ds-textfield>
      </form>
    </div>
  </div>

  <div mat-dialog-actions align="end" class="ds">
    <div class="dialog-btn-wrapper">
      <ds-button id="clearFiltersButton" variant="label-only" size="medium" type="secondary" (onClick)="clearAllFilters()"
        [label]="appStrings.accounts_clearFilters" [isDisabled]="!formHasValue">
      </ds-button>
      <ds-button id="searchButton" variant="label-only" size="medium" type="primary" (onClick)="searchText()"
        [label]="appStrings.accounts_search">
      </ds-button>
    </div>
  </div>
} @else {
  <!-- Desktop legacy template -->
  <div *appIsDesktop class="container quoteAdvancedSearch">
    <div class="legacy-title">
      <span>{{ appStrings.quotes_searchQuotes || appStrings.quotesSearch_advancedSearch_title }}</span>
      <button mat-icon-button class="close-dialog-button" mat-dialog-close>
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <div id="formContainer" class="form-container">
      <form [formGroup]="filterFormGroup">
        <div id="dateContainer">
          <!-- Start Date picker -->
          <mat-form-field appearance="outline" floatLabel="always" class="cursor flex-width"
            (click)="startDateInterval.open()">
            <mat-label id="startDateLabel">{{appStrings.quotesStartDate}}</mat-label>
            <input class="cursor" style="display: none;" matInput [matDatepicker]="startDateInterval" readonly
              formControlName="startDate" [max]="today" (dateChange)="updateCalendarLabelStartDate($event.value)">
            <input class="cursor" matInput readonly [value]="prettyStartDate">
            <mat-datepicker-toggle matSuffix [for]="startDateInterval"></mat-datepicker-toggle>
            <mat-datepicker #startDateInterval disabled="false"></mat-datepicker>
          </mat-form-field>

          <!-- End Date picker -->
          <mat-form-field appearance="outline" floatLabel="always" class="cursor flex-width"
            (click)="endDateInterval.open()">
            <mat-label id="endDateLabel">{{appStrings.quotesEndDate}}</mat-label>
            <input class="cursor" style="display: none;" matInput [matDatepicker]="endDateInterval" readonly
              formControlName="endDate" (dateChange)="updateCalendarLabelEndDate($event.value)">
            <input class="cursor" matInput readonly [value]="prettyEndDate">
            <mat-datepicker-toggle matSuffix [for]="endDateInterval"></mat-datepicker-toggle>
            <mat-datepicker #endDateInterval disabled="false"></mat-datepicker>
          </mat-form-field>
        </div>

        <div id="searchFormContent">
          <!-- Customer Name field -->
          @if (!data.isCustomerDashboard) {
            <div id="customerNameSearchForm" class="row">
              <span class="hint" id="customerNameLabel">{{appStrings.quoteSearch_customerName}}</span>
              <mat-form-field id="customerNameField" class="quotes-advanced-search-input-custom-size no-subscript search-field">
                <input matInput id="customerNameSearchField" formControlName="customerName" maxlength="100"
                  (keyup.enter)="searchText()">
                @if (filterFormGroup.controls.customerName.value && !data.customer) {
                  <span id="deleteNameButton" (click)="clearFilter('customerName')"
                    class="float-right delete-button crm-industrial-font icon-plus"></span>
                }
              </mat-form-field>
            </div>
          }

          <!-- BP Number field -->
          @if (!data.isCustomerDashboard) {
            <div id="bpNumberSearchForm" class="row">
              <span class="hint" id="bpNumberLabel">{{appStrings.quoteSearch_bpNumber}}</span>
              <mat-form-field id="bpNumberField" class="quotes-advanced-search-input-custom-size no-subscript">
                <mat-label></mat-label>
                <input matInput id="bpNumberSearchField" formControlName="bpNumber" maxlength="9" appDigitsOnly
                  placeholder="Ex. 0123456789" (keyup.enter)="searchText()">
                @if (filterFormGroup.controls.bpNumber.value && !data.customer) {
                  <span id="deleteBpNumberButton" (click)="clearFilter('bpNumber')"
                    class="float-right delete-button crm-industrial-font icon-plus"></span>
                }
              </mat-form-field>
            </div>
          }

          <!-- Quote Name field -->
          <div id="quoteNameSearchForm" class="row">
            <span class="hint" id="quoteNameLabel">{{appStrings.quoteSearch_quoteName}}</span>
            <mat-form-field id="quoteNameField" class="quotes-advanced-search-input-custom-size no-subscript">
              <input matInput id="quoteNameSearchField" formControlName="quoteName" maxlength="20"
                (keyup.enter)="searchText()">
              @if (filterFormGroup.controls.quoteName.value) {
                <span id="deleteContactButton" (click)="clearFilter('quoteName')"
                  class="float-right delete-button crm-industrial-font icon-plus"></span>
              }
            </mat-form-field>
          </div>

          <!-- Quote Number field -->
          <div id="quoteNumberSearchForm" class="row">
            <span class="hint" id="quoteNumberLabel">{{appStrings.quoteSearch_quoteNumber}}</span>
            <mat-form-field id="quoteNumberField" class="quotes-advanced-search-input-custom-size no-subscript">
              <input matInput id="quoteNumberSearchField" formControlName="quoteNumber" maxlength="20"
                placeholder="Ex. IMP-000011111" ng-trim="false" appSpecialCharactersValidations dashAllowed="true"
                appNoWhiteSpacesAllowed [noSpacesAllowed]="true" (keyup.enter)="searchText()">
              @if (filterFormGroup.controls.quoteNumber.value) {
                <span id="deleteContactButton" (click)="clearFilter('quoteNumber')"
                  class="float-right delete-button crm-industrial-font icon-plus"></span>
              }
            </mat-form-field>
          </div>

          <!-- Confidence to Close field -->
          <div id="confidenceSearchForm" class="row">
            <span class="hint" id="confidenceLabel">{{appStrings.quoteSearch_confidencePct}}</span>
            <mat-form-field id="confidenceField" class="quotes-advanced-search-input-custom-size no-subscript">
              <mat-select id="confidenceSelect" formControlName="confidence">
                @for (confidenceOption of confidenceOptions; track confidenceOption.key) {
                  <mat-option [value]="confidenceOption.key" id="confidence-{{confidenceOption.key}}">
                    {{confidenceOption.label}}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>

          <!-- Dollar Amount field -->
          <div id="dollarAmountSearchForm" class="row">
            <span class="hint" id="dollarAmountLabel">{{displayedTextAmount}}</span>
            <mat-form-field id="dollarAmountField" class="quotes-advanced-search-input-custom-size no-subscript">
              <mat-label></mat-label>
              @if (displayCurrency) {
                <span matPreffix>{{currencySymbol}}</span>
              }
              <input matInput type="text" id="dollarAmountSearchField" formControlName="dollarAmount" maxlength="15"
                appDigitsOnly [decimals]="2" [allowNegatives]="true" (keyup.enter)="searchText()">
              @if (filterFormGroup.controls.dollarAmount.value) {
                <span id="deleteContactButton" (click)="clearFilter('dollarAmount')"
                  class="float-right delete-button crm-industrial-font icon-plus"></span>
              }
            </mat-form-field>
          </div>

          <!-- Expiring in Days field -->
          <div id="expiringInDaysSearchForm" class="row">
            <span class="hint" id="expiringLabel">{{appStrings.quoteSearch_expiringInDays}}</span>
            <mat-form-field id="expiringField" class="quotes-advanced-search-input-custom-size no-subscript">
              <mat-label></mat-label>
              <input matInput id="expiringInput" formControlName="expiringInDays" maxlength="5" appDigitsOnly
                (keyup.enter)="searchText()">
              @if (filterFormGroup.controls.expiringInDays.value) {
                <span id="deleteExpiringButton" (click)="clearFilter('expiringInDays')"
                  class="float-right delete-button crm-industrial-font icon-plus"></span>
              }
            </mat-form-field>
          </div>

          <!-- Dollar Ranges fields -->
          <div id="dollarRangesSearchForm" class="row range-row">
            <span class="hint" id="dollarRangesLabel">{{ displayedTextRangesFrom }}</span>
            <div class="ranges-wrapper">
              <mat-form-field id="dollarRangesMinField" class="quotes-advanced-search-input-custom-size-small no-subscript-small">
                <mat-label></mat-label>
                @if (displayCurrency) {
                  <span matPreffix>{{currencySymbol}}</span>
                }
                <input matInput type="text" id="dollarRangesMinInput" formControlName="dollarRangeMin" maxlength="15"
                  appDigitsOnly [decimals]="2" (keyup.enter)="searchText()">
                @if (filterFormGroup.controls.dollarRangeMin.value) {
                  <span id="deleteRangeMinButton" (click)="clearFilter('dollarRangeMin')"
                    class="float-right delete-button crm-industrial-font icon-plus"></span>
                }
              </mat-form-field>
              <span class="ranges-separator">&</span>
              <mat-form-field id="dollarRangesMaxField" class="quotes-advanced-search-input-custom-size-small no-subscript-small">
                <mat-label></mat-label>
                @if (displayCurrency) {
                  <span matPreffix>{{currencySymbol}}</span>
                }
                <input matInput type="text" id="dollarRangesMaxInput" formControlName="dollarRangeMax" maxlength="15"
                  appDigitsOnly [decimals]="2" (keyup.enter)="searchText()">
                @if (filterFormGroup.controls.dollarRangeMax.value) {
                  <span id="deleteRangeMaxButton" (click)="clearFilter('dollarRangeMax')"
                    class="float-right delete-button crm-industrial-font icon-plus"></span>
                }
              </mat-form-field>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div id="buttonsContainer" class="buttons-container">
      <span id="clearFiltersButton" class="strong cursor-pointer" (click)="clearAllFilters()"
        [ngClass]="{'disabled': !formHasValue}">
        {{appStrings.accounts_clearFilters}}
      </span>
      <button [disabled]="!formHasValue" type="button" id="searchButton"
        class="button primary mat-stroked-button search-button" (click)="searchText()">
        <span id="searchButtonLabel" class="crm-industrial-font icon-search"></span>
        <span>{{appStrings.accounts_search}}</span>
      </button>
    </div>
  </div>

  <!-- Mobile legacy template -->
  <div *appIsMobile class="container quoteAdvancedSearch mobile">
    <div class="legacy-title">
      <span>{{ appStrings.quotes_searchQuotes || appStrings.quotesSearch_advancedSearch_title }}</span>
      <button mat-icon-button class="close-dialog-button" mat-dialog-close>
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <form [formGroup]="filterFormGroup">
      <div id="formContainer" class="form-container">
        <div id="startDateSearchForm" class="input small">
          <span id="label" class="label">{{ appStrings.quotesStartDate }}</span>
          <mat-form-field appearance="outline" class="cursor flex-width no-subscript"
            (click)="startDateIntervalMobile.open()">
            <input class="cursor" style="display: none;" matInput [matDatepicker]="startDateIntervalMobile" readonly
              formControlName="startDate" [max]="today" (dateChange)="updateCalendarLabelStartDate($event.value)">
            <input class="cursor" matInput readonly [value]="prettyStartDate" placeholder="Select">
            <mat-datepicker-toggle matSuffix [for]="startDateIntervalMobile"></mat-datepicker-toggle>
            <mat-datepicker #startDateIntervalMobile disabled="false"></mat-datepicker>
          </mat-form-field>
        </div>

        <div id="endDateSearchForm" class="input small">
          <span id="label" class="label">{{ appStrings.quotesEndDate }}</span>
          <mat-form-field appearance="outline" class="cursor flex-width no-subscript"
            (click)="endDateIntervalMobile.open()">
            <input class="cursor" style="display: none;" matInput [matDatepicker]="endDateIntervalMobile" readonly
              formControlName="endDate" (dateChange)="updateCalendarLabelEndDate($event.value)">
            <input class="cursor" matInput readonly [value]="prettyEndDate" placeholder="Select">
            <mat-datepicker-toggle matSuffix [for]="endDateIntervalMobile"></mat-datepicker-toggle>
            <mat-datepicker #endDateIntervalMobile disabled="false"></mat-datepicker>
          </mat-form-field>
        </div>

        @if (!data.isCustomerDashboard) {
          <div id="customerNameSearchForm" class="input">
            <span id="label" class="label">{{ appStrings.quoteSearch_customerName }}</span>
            <mat-form-field appearance="outline" id="customerNameField" class="no-subscript">
              <input matInput id="customerNameSearchField" formControlName="customerName" maxlength="100"
                (keyup.enter)="searchText()" placeholder="Type Name">
              @if (filterFormGroup.controls.customerName.value && !data.customer) {
                <span id="deleteNameButton" (click)="clearFilter('customerName')"
                  class="float-right delete-button crm-industrial-font icon-remove"></span>
              }
            </mat-form-field>
          </div>
        }

        @if (!data.isCustomerDashboard) {
          <div id="bpNumberSearchForm" class="input">
            <span id="label" class="label">{{ appStrings.quoteSearch_bpNumber }}</span>
            <mat-form-field appearance="outline" id="bpNumberField" class="no-subscript">
              <input matInput id="bpNumberSearchField" formControlName="bpNumber" maxlength="9" appDigitsOnly
                (keyup.enter)="searchText()" placeholder="Type Number">
              @if (filterFormGroup.controls.bpNumber.value && !data.customer) {
                <span id="deleteBpNumberButton" (click)="clearFilter('bpNumber')"
                  class="float-right delete-button crm-industrial-font icon-remove"></span>
              }
            </mat-form-field>
          </div>
        }

        <div id="quoteNameSearchForm" class="input">
          <span id="label" class="label">{{ appStrings.quoteSearch_quoteName }}</span>
          <mat-form-field appearance="outline" id="quoteNameField" class="no-subscript">
            <input matInput id="quoteNameSearchField" formControlName="quoteName" maxlength="20"
              (keyup.enter)="searchText()" placeholder="Type Name">
            @if (filterFormGroup.controls.quoteName.value) {
              <span id="deleteContactButton" (click)="clearFilter('quoteName')"
                class="float-right delete-button crm-industrial-font icon-remove"></span>
            }
          </mat-form-field>
        </div>

        @if (!data.isCustomerDashboard) {
          <div id="quoteNumberSearchForm" class="input">
            <span id="label" class="label">{{ appStrings.quoteSearch_quoteNumber }}</span>
            <mat-form-field appearance="outline" id="quoteNumberField" class="no-subscript">
              <input matInput id="quoteNumberSearchField" formControlName="quoteNumber" maxlength="20"
                placeholder="Ex. IMP-000011111" ng-trim="false" appSpecialCharactersValidations dashAllowed="true"
                appNoWhiteSpacesAllowed [noSpacesAllowed]="true" (keyup.enter)="searchText()">
              @if (filterFormGroup.controls.quoteNumber.value) {
                <span id="deleteContactButton" (click)="clearFilter('quoteNumber')"
                  class="float-right delete-button crm-industrial-font icon-remove"></span>
              }
            </mat-form-field>
          </div>
        }

        @if (!data.isCustomerDashboard) {
          <div id="confidenceSearchForm" class="input small">
            <span id="label" class="label">{{ appStrings.quoteSearch_confidencePct }}</span>
            <mat-form-field appearance="outline" id="confidenceField" class="no-subscript">
              <mat-select placeholder="All" id="confidenceSelect" formControlName="confidence">
                <mat-option>All</mat-option>
                @for (confidenceOption of confidenceOptions; track confidenceOption.key) {
                  <mat-option [value]="confidenceOption.key" id="confidence-{{confidenceOption.key}}">
                    {{confidenceOption.label}}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        }

        <div id="expiringInDaysSearchForm" class="input small">
          <span id="label" class="label">{{ appStrings.quoteSearch_expiringInDays }}</span>
          <mat-form-field appearance="outline" id="expiringField" class="no-subscript">
            <input matInput id="expiringInput" formControlName="expiringInDays" maxlength="5" appDigitsOnly
              (keyup.enter)="searchText()" placeholder="Type Number">
            @if (filterFormGroup.controls.expiringInDays.value) {
              <span id="deleteExpiringButton" (click)="clearFilter('expiringInDays')"
                class="float-right delete-button crm-industrial-font icon-remove"></span>
            }
          </mat-form-field>
        </div>

        <div id="dollarAmountSearchForm" class="input">
          <span id="label" class="label">{{ displayedTextAmount }}</span>
          <mat-form-field appearance="outline" id="dollarAmountField" class="no-subscript">
            @if (displayCurrency) {
              <span matPreffix class="currency">{{currencySymbol}}</span>
            }
            <input matInput type="text" id="dollarAmountSearchField" formControlName="dollarAmount" maxlength="15"
              appDigitsOnly [decimals]="2" [allowNegatives]="true" (keyup.enter)="searchText()" placeholder="Type Amount">
            @if (filterFormGroup.controls.dollarAmount.value) {
              <span id="deleteContactButton" (click)="clearFilter('dollarAmount')"
                class="float-right delete-button crm-industrial-font icon-remove"></span>
            }
          </mat-form-field>
        </div>

        <div id="dollarRangesMinSearchForm" class="input small">
          <span id="label" class="label">{{ displayedTextRangesFrom }}</span>
          <mat-form-field appearance="outline" id="dollarRangesMinField" class="no-subscript">
            @if (displayCurrency) {
              <span matPreffix class="currency">{{currencySymbol}}</span>
            }
            <input matInput type="text" id="dollarRangesMinInput" formControlName="dollarRangeMin" maxlength="15"
              appDigitsOnly [decimals]="2" (keyup.enter)="searchText()" placeholder="Type">
            @if (filterFormGroup.controls.dollarRangeMin.value) {
              <span id="deleteRangeMinButton" (click)="clearFilter('dollarRangeMin')"
                class="crm-industrial-font icon-remove"></span>
            }
          </mat-form-field>
        </div>

        <div id="dollarRangesMaxSearchForm" class="input small">
          <span id="label" class="label">{{ displayedTextRangesTo }}</span>
          <mat-form-field appearance="outline" id="dollarRangesMaxField" class="no-subscript">
            @if (displayCurrency) {
              <span matPreffix class="currency">{{currencySymbol}}</span>
            }
            <input matInput type="text" id="dollarRangesMaxInput" formControlName="dollarRangeMax" maxlength="15"
              appDigitsOnly [decimals]="2" (keyup.enter)="searchText()" placeholder="Type">
            @if (filterFormGroup.controls.dollarRangeMax.value) {
              <span id="deleteRangeMaxButton" (click)="clearFilter('dollarRangeMax')"
                class="crm-industrial-font icon-remove"></span>
            }
          </mat-form-field>
        </div>
      </div>
    </form>
    <div id="buttonsContainer" class="buttons-container">
      <button [disabled]="!formHasValue" type="button" id="searchButton" mat-button class="button mat-button" (click)="searchText()">
        <span id="searchButtonLabel" class="crm-industrial-font icon-search"></span>
        <span>{{appStrings.accounts_search}}</span>
      </button>
      <span id="clearFiltersButton" class="cursor-pointer" (click)="clearAllFilters()"
        [ngClass]="{'disabled': !formHasValue}">
        {{appStrings.accounts_clearFilters}}
      </span>
    </div>
  </div>
}